import { jsx as _jsx } from "react/jsx-runtime";
import { memo, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useSelectedDatasetId, useControlData, useControlLabel, useIsLoading, } from 'Datasets/store/selectors';
import { selectDatasetByVersionId } from 'Datasets/store/datasetSelector.slice';
import DatasetControl from './DatasetControl';
export const DatasetControlContainer = ({ onChange, className, }) => {
    const dispatch = useDispatch();
    const selectedDatasetId = useSelectedDatasetId();
    const data = useControlData();
    const label = useControlLabel();
    const isLoading = useIsLoading();
    const handleChange = useCallback((datasetId) => {
        dispatch(selectDatasetByVersionId(datasetId));
        if (onChange) {
            onChange(datasetId);
        }
    }, [dispatch, onChange]);
    return (_jsx(DatasetControl, { className: className, data: data, selectedDatasetId: selectedDatasetId, onChange: handleChange, isLoading: isLoading, label: label }, void 0));
};
export default memo(DatasetControlContainer);
